<template>
    <el-dialog
        class="ro-record-dialog"
        title="申请记录"
        :visible.sync="visible"
        :before-close="close"
        width="800px"
    >
        <div>
            <el-table :data="recordData" v-loading="loading" border>
                <el-table-column prop="createUserName" label="申请人" width="100px"></el-table-column>
                <el-table-column prop="createTime" label="申请日期" width="160px"></el-table-column>
                <el-table-column prop="auditStatus" label="审批结果" width="160px">
                    <template slot-scope="scope">
                        <m-select :value="scope.row.auditStatus" :optionArr="auditStatusOptions" disabled></m-select>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="auditMipId" label="操作" width="80px">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.auditStatus === AUDIT_STATUS.REJECT" type="text" size="mini" @click="handleResubmit(scope.row.auditMipId)">重新提交</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-container">
                <m-page ref="page"
                    :current-page="page.pageNo"
                    :pageData="pageConfig"
                    :total="page.pageTotal"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange"
                ></m-page>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import { getDictionary } from '../../utils/getDictionary.js';
import { getSupMipAudits, reSubmitFlow } from '../../api/rushOrder/rushOrderAuthApply.js';
import { AUDIT_TYPE, AUDIT_STATUS } from '../../constant/constant.js'
import MPage from '@/components/supplierPanel/mPage';
import MSelect from '@/components/lots/otpSelect2/index';

export default {
    components: { MPage, MSelect },
    data() {
        return {
            AUDIT_STATUS,
            visible: false,
            recordData: [],
            loading: false,
            page: {
                pageTotal: 0,
                pageNo: 1,
                pageSize: 10
            },
            pageConfig: {
                layout: 'total, sizes, prev, pager, next',
                pageSize: 10
            },
            auditStatusOptions: [],
        };
    },
    computed: {
        ...mapState(['supplier']),
    },
    methods: {
        open() {
            this.visible = true;
            this.loading = true;
            getDictionary('SRM_AUDIT_STATUS').then(options => {
                this.auditStatusOptions = options;
                this.load();
            }).catch(err => { this.loading = false; });
        },
        close() {
            this.recordData = [];
            this.page.pageTotal = 0;
            this.page.pageNo = 1;
            this.visible = false;
            this.tableShow = false;
        },
        pageChange(val) {
            this.page.pageNo = val;
            this.load();
        },
        sizeChange(val) {
            this.page.pageNo = 1;
            this.page.pageSize = val;
            this.load();
        },
        load() {
            const params = {
                businessCode: this.supplier.supplierCode,
                auditType: AUDIT_TYPE.RUSH_ORDER,
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            };
            this.loading = true;
            getSupMipAudits(params).then(res => {
                if (res && +res.code === 0) {
                    this.recordData = res.data.list;
                    // this.recordData = [{ auditStatus: '27' }, { auditStatus: '29' }, { auditStatus: '36' }];
                    this.page.pageTotal = res.data.totalCount;
                }
            }).catch(err => {}).finally(() => { this.loading = false; });
        },
        handleResubmit(auditMipId) {
            this.loading = true
            reSubmitFlow({ fdId: auditMipId }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('重新提交成功!')
                    this.close()
                }
            }).finally(() => { this.loading = false })
        }
    }
};
</script>
<style lang="less">
.ro-record-dialog {
    .el-table {
        margin-bottom: 10px;
    }
    .page-container {
        overflow: hidden;
    }
    .record-none {
        font-size: 13px;
        text-align: center;
    }
    .otp-select {
        .el-input.is-disabled .el-input__inner {
            background-color: transparent;
            border-width: 0;
            color: #666;
            padding-right: 6px;
        }
        .el-input__suffix {
            display: none;
        }
    }
    .el-button {
        font-size: 12px;
    }
}
</style>
